'use es6';

import { FETCH } from 'dashboard-lib/public/request/request-type';
import * as TeamDao from 'dashboard-lib/public/team/team-dao';
import { createRequestAction } from 'dashboard-lib/public/request/create-request-action';
export const namespace = 'team';
export const fetchAllTeam = createRequestAction(`${namespace}_${FETCH}`, TeamDao.getAllTeam);
export const fetchAllTeamActions = fetchAllTeam.actions;